import useSelector from '@app/hooks/useSelector';

import { getEnabledTriggers, getIntegrationsConfig } from '../../../../reducers/downloadData/selectors';
import type { Triggers } from '../../../../types';
import TriggersCheckboxes from './TriggersCheckboxes';

type Value = {
    triggers: Triggers;
    defaultBitbucketReviewers: boolean;
};

interface TriggersCheckboxesContainerProps {
    value: Value;
    onChange: (value: Value) => void;
}

const TriggersCheckboxesContainer = (props: TriggersCheckboxesContainerProps) => {
    const enabledTriggers = useSelector(getEnabledTriggers);
    const integrationsConfig = useSelector(getIntegrationsConfig);

    if (enabledTriggers === undefined) {
        return null;
    }

    if (integrationsConfig === undefined) {
        return null;
    }

    return <TriggersCheckboxes {...props} enabledTriggers={enabledTriggers} integrationsConfig={integrationsConfig} />;
};

export default TriggersCheckboxesContainer;
